<div class="br-dialog-shell field-dialog-shell">
  <header class="br-dialog-header">
    <div class="field-dialog-header">
      <h2 mat-dialog-title class="br-dialog-title">{{ data.title }}</h2>
      <button type="button" class="br-btn-close" mat-dialog-close aria-label="Close"></button>
    </div>
  </header>

  <mat-dialog-content class="br-dialog-body">
    <div class="field-dialog-container">
      <div class="field-form">
        <label class="field-control" *ngIf="data.availableFields?.length">
          <span class="br-form-label">Use an existing field</span>
          <select
              class="br-form-select"
              [ngModel]="selectedExistingKey"
              (ngModelChange)="selectExistingField($event)">
            <option value="">Create a new field</option>
            <option *ngFor="let available of data.availableFields" [value]="available.key">
              {{ available.label }}
            </option>
          </select>
          <span class="field-hint">The same field can be used in more than one node.</span>
        </label>

        <label class="field-control">
          <span class="br-form-label">Field name <span class="br-required-mark" aria-hidden="true">*</span></span>
          <input
              class="br-form-control"
              [ngModel]="field.label"
              (ngModelChange)="onFieldNameChanged($event)"
              maxlength="128"
              required
              placeholder="Potential earning"
              [readonly]="definitionLocked" />
          <span class="field-hint">Shown in forms, tables, and reports.</span>
        </label>

        <label class="field-control">
          <span class="br-form-label">Internal key <span class="br-required-mark" aria-hidden="true">*</span></span>
          <input
              class="br-form-control"
              [(ngModel)]="field.key"
              maxlength="64"
              required
              placeholder="potential_earning"
              [readonly]="data.keyLocked || definitionLocked" />
          <span class="field-hint">
            Unique identifier used by APIs and workflow rules. Use lowercase letters,
            numbers, and underscores.
          </span>
        </label>

        <label class="field-control">
          <span class="br-form-label">Type <span class="br-required-mark" aria-hidden="true">*</span></span>
          <select
              class="br-form-select"
              [(ngModel)]="field.dataType"
              required
              [disabled]="data.typeLocked || definitionLocked"
              (ngModelChange)="onTypeChanged()">
            <option *ngFor="let type of fieldTypes" [ngValue]="type.value">
              {{ type.label }}
            </option>
          </select>
        </label>

        <label class="field-control">
          <span class="br-form-label">Description</span>
          <input
              class="br-form-control"
              [(ngModel)]="field.description"
              maxlength="255"
              [readonly]="definitionLocked" />
        </label>
      </div>

      <div class="field-flags">
        <mat-checkbox [(ngModel)]="field.isRequired">
          Required
        </mat-checkbox>
      </div>

      <section class="br-card br-card-body choice-options" *ngIf="field.dataType === 'choice'">
        <div class="br-flex br-items-center br-justify-between br-gap-2 br-mb-2">
          <div>
            <h3 class="br-mb-0">Choice options</h3>
            <p class="br-text-muted br-mb-0">Add the values users can select for this field.</p>
          </div>
          <button
              *ngIf="!definitionLocked"
              type="button"
              class="br-btn br-btn--outline-primary br-btn--sm"
              (click)="addOption()">
            <br-icon>add</br-icon> Add option
          </button>
        </div>

        <div class="choice-row" *ngFor="let option of field.options; let index = index">
          <label class="field-control">
            <span class="br-form-label">Option name <span class="br-required-mark" aria-hidden="true">*</span></span>
            <input
                class="br-form-control"
                [(ngModel)]="option.label"
                maxlength="128"
                required
                [readonly]="definitionLocked" />
          </label>
          <label class="field-control">
            <span class="br-form-label">Internal key <span class="br-required-mark" aria-hidden="true">*</span></span>
            <input
                class="br-form-control"
                [(ngModel)]="option.key"
                maxlength="64"
                required
                [readonly]="definitionLocked" />
          </label>
          <mat-checkbox [(ngModel)]="option.isActive" [disabled]="definitionLocked">Active</mat-checkbox>
          <button
              *ngIf="!definitionLocked"
              type="button"
              mat-icon-button
              (click)="removeOption(index)"
              aria-label="Remove option">
            <br-icon>delete</br-icon>
          </button>
        </div>
      </section>
    </div>
  </mat-dialog-content>

  <footer class="br-dialog-footer">
    <div class="field-dialog-actions">
      <span class="field-error" *ngIf="error">{{ error }}</span>
      <button type="button" class="br-btn br-btn--outline-secondary" mat-dialog-close>Cancel</button>
      <button type="button" class="br-btn br-btn--primary" (click)="save()">Save field</button>
    </div>
  </footer>
</div>
